class ProductForm extends HTMLElement {
  
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = this.form.querySelector('[type="submit"]');

    if (document.querySelector('cart-drawer')) {
      this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  onSubmitHandler(e) {
    e.preventDefault();
    if(this.submitButton.getAttribute('aria-disabled') === 'true') {
      return
    };

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.setAttribute('data-state', 'loading');

    const formData = new FormData(this.form);
    if(this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        Accept: `application/javascript`,
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then((response) => response.json())
    .then((response) => {
      if(response.status) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').text = 'Sold out';
        this.error = true;
        this.handleErrorMessage(response.description);
        return;
      }
      else if(!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
      this.error = false;
      this.cart.renderContents(response);
    })
    .catch((e) =>  {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.removeAttribute('data-state');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    })

    
  }

  renderCartDrawer() {
    fetch(`/?sections=${this.cart.getSectionsToRender().map((section) => section.id).join(',')}`)
      .then(response => response.json())
      .then(response => {
        this.cart.renderContents(response);
      })
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

}

customElements.define('product-form', ProductForm);